export default __webpack_public_path__ + "static/media/camera.a5506cb8.svg";